import React from 'react';
import { Link as RouterLink } from 'react-router-dom';

import {
  IdeaDrafts,
  WhitePaperDrafts
} from 'buyside/components/presentation/ResearchSubmissionPage/ResearchDrafts/researchDrafts';
import { RESEARCH_SUBMISSION_TYPES } from 'buyside/components/presentation/ResearchSubmissionPage/researchSubmissionPage';
import Button, { BUTTON_TYPES, BUTTON_WIDTHS } from 'buyside/components/presentation/Button/button';
import Link from 'buyside/components/presentation/Link/link';

import { qualityGuidelinesUrl, userAccountIdeasUrl } from 'buyside/util/urlHelper';

import styles from './researchTypeSelectorStyles.scss';

const ResearchTypeSelector: React.FC<{
  researchTypes: typeof RESEARCH_SUBMISSION_TYPES[keyof typeof RESEARCH_SUBMISSION_TYPES][];
}> = ({ researchTypes }) => {
  return (
    <div className={styles.researchTypeSelector}>
      <div className={styles.researchTypesHeader}>
        <h4>Submit Research</h4>
      </div>
      <div className={styles.researchTypes}>
        {researchTypes.map(({ description, name, route }) => (
          <div key={'new-' + name}>
            <p data-name>{name}</p>
            <p data-description>{description}</p>
            <RouterLink to={route}>
              <Button text="Start Draft" type={BUTTON_TYPES.MAJOR} width={BUTTON_WIDTHS.FULL} />
            </RouterLink>
            {name === 'Macro/Thematic' ? <WhitePaperDrafts /> : null}
            {name === 'Idea' ? (
              <>
                <IdeaDrafts />
                <Button
                  className={styles.viewAllIdeas}
                  text="View All Your Ideas"
                  type={BUTTON_TYPES.LINK}
                  url={userAccountIdeasUrl()}
                />
                <p data-disclaimer>
                  <strong>Important:</strong> Please review the{' '}
                  <Link to={qualityGuidelinesUrl()} target="_blank">
                    SumZero Quality Guidelines{' '}
                  </Link>
                  before submitting an idea.
                </p>
              </>
            ) : null}
          </div>
        ))}
      </div>
    </div>
  );
};

export default ResearchTypeSelector;
